// eslint-disable-next-line no-restricted-imports

import * as React from 'react';
import { DrawerOverlay } from '@99designs/apps/spa/common/DrawerOverlay/DrawerOverlay';
import { ModalBody, ModalHeader } from '@99designs/apps/spa/common/Modal';
import { DesignerCard_UserFragment } from '@99designs/apps/spa/pages/create/components/DesignerCard.generated';
import { Box } from '@99designs/emu';
import { Button } from '@99designs/frontend-components/components/Button';
import Contacts from './Contacts';
import ContactsButton from './ContactsButton';

interface Props {
    brief: {
        id: string;
        designers: DesignerCard_UserFragment[];
        contacts: DesignerCard_UserFragment[];
    };
}

interface State {
    showing: boolean;
}

class ContactsDrawer extends React.Component<Props, State> {
    state = {
        showing: false,
    };

    componentDidUpdate(prev: Props) {
        if (
            prev.brief.designers.length !== 0 &&
            this.props.brief.designers.length === 0 &&
            this.props.brief.contacts.length === 0
        ) {
            this.hideOverlay();
        }
    }

    hideOverlay = () => {
        this.setState({ showing: false });
    };

    showOverlay = () => {
        this.setState({ showing: true });
    };

    render() {
        const { showing } = this.state;
        const { brief } = this.props;

        return (
            <>
                <ContactsButton onClick={this.showOverlay} />
                <DrawerOverlay showing={showing} variations={['wide']} onClose={this.hideOverlay}>
                    <div className="contacts-drawer" data-testid="contacts-drawer">
                        <ModalHeader>
                            <div className="heading heading--h3 heading--no-margin">
                                {__('Your contacts')}
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <Contacts brief={brief} />
                            <div className="contacts-drawer__done-cta">
                                <Box color="grey800">
                                    <Button
                                        variations={[
                                            'primary',
                                            'nowrap',
                                            'responsive',
                                            'chameleon',
                                            'fluid',
                                        ]}
                                        onClick={this.hideOverlay}
                                        data-testid="contacts-drawer-confirm-button"
                                    >
                                        {__('Confirm')}
                                    </Button>
                                </Box>
                            </div>
                        </ModalBody>
                    </div>
                </DrawerOverlay>
            </>
        );
    }
}

export default ContactsDrawer;
